import { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import withRouter from '../../../../hoc/withRouter';
import TextInput from '../../../../components/common/form/elements/text-input';

class AuditAmount extends Component {
  render() {
    const {
      onBlur, isAuditCompleted, hasIncentiveId, hasPostcodeplanObjectiveId,
      status, auditAmounts, isAudit, isAdmin
    } = this.props;

    return (
      <div>
        <Row>
          <Col md={12}>
            {hasIncentiveId && (
              <TextInput
                onBlur={onBlur}
                label='Audit Amount'
                model='.audit_amount'
                required={isAuditCompleted || isAudit}
                disabled={status === 'APPROVED' || (status === 'DECLINED' && !isAdmin)}
              />
            )}
            {hasPostcodeplanObjectiveId && auditAmounts && (
              <div>
                Audit amount: <br></br>
                Number of packs sold
                  {auditAmounts.map((auditAmount, index) => (
                    <Row key={index}>
                      <Col md={2} style={{ marginTop: 10 }}>
                        {auditAmount.label}
                      </Col>
                      <Col md={8}>
                        <TextInput
                          onBlur={onBlur}
                          model={`.audit_amounts.${index}.value`}
                          disabled={status === 'VALIDATED' || (status === 'DECLINED' && !isAdmin)}
                        />
                      </Col>
                    </Row>
                  ))}
              </div>
              )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  isAdmin: ownProps.location.pathname.includes('admin')
});

export default withRouter(connect(mapStateToProps)(AuditAmount));
